/* ============================================================
   Siora — Cart drawer behaviour:
   1) Coupons slide-over panel + native /discount/ apply.
   2) Free-gift system: auto-adds a configured product once the cart
      reaches the threshold (item count, excluding the gift), and removes
      it when the cart drops below. Re-renders the drawer via Dawn's
      Section Rendering API. (For the gift to be FREE, set a matching
      "Buy X Get Y" automatic discount in Admin.)
   ============================================================ */
(function () {
  var PANEL, OVERLAY;
  var q = function (s, r) { return (r || document).querySelector(s); };

  /* ---------- coupons panel ---------- */
  function recompute() {
    if (!PANEL) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        PANEL.querySelectorAll('.scp-card').forEach(function (card) {
          var min = parseInt(card.getAttribute('data-min') || '0', 10);
          card.classList.toggle('locked', c.total_price < min);
        });
      }).catch(function () {});
  }
  var COUPON_TRIGGER = null;
  function openCoupons() {
    if (!PANEL) return;
    COUPON_TRIGGER = document.activeElement;
    recompute();
    PANEL.classList.add('open'); OVERLAY && OVERLAY.classList.add('open');
    PANEL.setAttribute('aria-hidden', 'false');
    var m = q('.scp-msg', PANEL); if (m) { m.textContent = ''; m.className = 'scp-msg'; }
    document.body.style.overflow = 'hidden';
    var input = q('#scp-input', PANEL);
    if (input) setTimeout(function () { try { input.focus(); } catch (e) {} }, 90);
  }
  function closeCoupons() {
    if (!PANEL) return;
    PANEL.classList.remove('open'); OVERLAY && OVERLAY.classList.remove('open');
    PANEL.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (COUPON_TRIGGER && COUPON_TRIGGER.focus) { try { COUPON_TRIGGER.focus(); } catch (e) {} COUPON_TRIGGER = null; }
  }
  function couponMsg(text, ok) {
    if (!PANEL) return;
    var m = q('.scp-msg', PANEL);
    if (m) { m.textContent = text || ''; m.className = 'scp-msg' + (text ? (ok ? ' ok' : ' err') : ''); }
  }
  // Apply a discount code fully via AJAX — no page reload. Uses the Cart AJAX API's
  // /cart/update.js { discount } (Shopify, 2025+) with Section Rendering so the drawer
  // re-renders with the applied discount in place. The code must exist in Admin → Discounts.
  var applyingCode = false;
  function applyCode(code) {
    code = (code || '').trim();
    if (!code || applyingCode) return;
    applyingCode = true;
    showLoader();
    couponMsg('Applying…', true);
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code, sections: sectionsToRender(), sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        applyCartSections(state);            // re-render drawer + cart bubble with the applied discount
        recompute();                         // re-evaluate the panel's locked/unlocked cards
        var hit = (state.discount_codes || []).filter(function (d) {
          return d.code && d.code.toLowerCase() === code.toLowerCase();
        })[0];
        if (hit && hit.applicable !== false) {
          couponMsg('Coupon “' + code + '” applied ✓', true);
          var input = q('#scp-input', PANEL); if (input) input.value = '';
          setTimeout(closeCoupons, 950);     // slide back to the cart so they see the new total
        } else {
          // code exists but Shopify says it's not applicable, OR it doesn't exist as a
          // real Discount. Either way don't leave the dud code stuck on the cart.
          couponMsg('“' + code + '” isn’t valid for this cart (check it exists in Admin → Discounts).', false);
          fetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: '', sections: sectionsToRender(), sections_url: location.pathname })
          }).then(function (r) { return r.json(); }).then(function (s) { applyCartSections(s); recompute(); }).catch(function () {});
        }
      })
      .catch(function () { couponMsg('Couldn’t apply — please try again.', false); })
      .finally(function () {
        applyingCode = false;
        setTimeout(hideLoader, 250);
      });
  }
  // Remove the applied discount(s) — AJAX, no reload.
  var removingCode = false;
  function removeCoupon() {
    if (removingCode) return;
    removingCode = true;
    showLoader();
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '', sections: sectionsToRender(), sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) { applyCartSections(state); recompute(); couponMsg('', true); })
      .catch(function () {})
      .finally(function () { removingCode = false; setTimeout(hideLoader, 200); });
  }

  /* ---------- order-note bottom sheet ---------- */
  var NOTE, NOTE_OVERLAY, NOTE_FOCUS;
  function noteEls() { NOTE = document.querySelector('.siora-note-sheet'); NOTE_OVERLAY = document.querySelector('.siora-note-overlay'); }
  function noteCount() {
    if (!NOTE) return;
    var ta = q('#siora-note-input', NOTE), c = q('#siora-note-count', NOTE);
    if (ta && c) c.textContent = (ta.value || '').length;
  }
  function openNote(trigger) {
    if (!NOTE) noteEls();
    if (!NOTE) return;
    NOTE_FOCUS = document.activeElement;
    var ta = q('#siora-note-input', NOTE);
    if (ta) { ta.value = (trigger && trigger.getAttribute('data-note')) || ''; noteCount(); }
    NOTE.classList.add('open'); NOTE_OVERLAY && NOTE_OVERLAY.classList.add('open');
    NOTE.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (ta) setTimeout(function () { try { ta.focus(); } catch (e) {} }, 130);
  }
  function closeNote() {
    if (!NOTE) return;
    NOTE.classList.remove('open'); NOTE_OVERLAY && NOTE_OVERLAY.classList.remove('open');
    NOTE.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (NOTE_FOCUS && NOTE_FOCUS.focus) { try { NOTE_FOCUS.focus(); } catch (e) {} NOTE_FOCUS = null; }
  }
  var savingNote = false;
  function saveNote() {
    if (!NOTE || savingNote) return;
    savingNote = true;
    var ta = q('#siora-note-input', NOTE), val = ta ? ta.value : '';
    var btn = q('.snote-save', NOTE); if (btn) { btn.disabled = true; btn.textContent = 'Saving…'; }
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: val, sections: sectionsToRender(), sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) { applyCartSections(state); closeNote(); })
      .catch(function () {})
      .finally(function () { savingNote = false; if (btn) { btn.disabled = false; btn.textContent = 'Save note'; } });
  }

  /* ---------- free-shipping progress bar + celebration ---------- */
  var shipUnlockedBefore = false;
  var shipLastPct = 0;
  function animateShipFill() {
    var bar = document.querySelector('[data-ship-bar]');
    if (!bar) return;
    var fill = bar.querySelector('.sc-ship__fill');
    if (!fill) return;
    var pct = parseInt(bar.getAttribute('data-ship-pct') || '0', 10);
    // start from the previous fill so it animates fill/drain (runs before paint, so no flicker)
    fill.style.width = shipLastPct + '%';
    requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.width = pct + '%'; }); });
    shipLastPct = pct;
  }
  function celebrate() {
    try {
      var host = document.querySelector('cart-drawer'); if (!host) return;
      var old = host.querySelector('.sc-confetti'); if (old) old.remove();
      var wrap = document.createElement('div'); wrap.className = 'sc-confetti';
      var colors = ['#f26b1d', '#ffb347', '#2fb96b', '#57e08a', '#ffd93b', '#ff6b6b', '#4d9dff', '#ffffff'];
      for (var i = 0; i < 64; i++) {
        var s = document.createElement('span');
        s.style.background = colors[Math.floor(Math.random() * colors.length)];
        s.style.left = (Math.random() * 100).toFixed(2) + '%';
        s.style.setProperty('--dx', (Math.random() * 2 - 1).toFixed(2));
        s.style.setProperty('--rot', Math.floor(Math.random() * 720 - 360) + 'deg');
        s.style.setProperty('--delay', (Math.random() * 0.25).toFixed(2) + 's');
        s.style.setProperty('--dur', (0.9 + Math.random() * 0.8).toFixed(2) + 's');
        if (Math.random() > 0.55) s.style.borderRadius = '50%';
        wrap.appendChild(s);
      }
      host.appendChild(wrap);
      setTimeout(function () { if (wrap.parentNode) wrap.remove(); }, 2400);
    } catch (e) {}
  }
  function checkFreeShip() {
    var bar = document.querySelector('[data-ship-bar]');
    animateShipFill();
    var unlocked = !!(bar && bar.getAttribute('data-ship-unlocked') === '1');
    if (unlocked && !shipUnlockedBefore) celebrate();
    shipUnlockedBefore = unlocked;
  }
  function initFreeShip() {
    var bar = document.querySelector('[data-ship-bar]');
    shipUnlockedBefore = !!(bar && bar.getAttribute('data-ship-unlocked') === '1');
    animateShipFill();
  }

  function openCartDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); return; }
    var b = document.querySelector('#cart-icon-bubble'); if (b) b.click();
  }

  /* ---------- free gift ---------- */
  var GIFT = { enable: false, variant: 0, threshold: 2, busy: false };
  function readGiftCfg() {
    var el = document.getElementById('siora-cart-config');
    if (!el) return;
    GIFT.enable = el.getAttribute('data-gift-enable') === 'true';
    GIFT.variant = parseInt(el.getAttribute('data-gift-variant') || '0', 10) || 0;
    GIFT.threshold = parseInt(el.getAttribute('data-gift-threshold') || '2', 10) || 0;
  }
  function sectionsToRender() {
    var d = document.querySelector('cart-drawer');
    return (d && d.getSectionsToRender) ? d.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
  }
  function renderDrawer(parsed) {
    var d = document.querySelector('cart-drawer');
    if (d && d.renderContents && parsed && parsed.sections) d.renderContents(parsed);
  }
  function checkGift() {
    if (!GIFT.enable || !GIFT.variant || !GIFT.threshold || GIFT.busy) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var giftLine = null, units = 0;
        c.items.forEach(function (it) {
          var isGift = it.properties && (it.properties._free_gift === 'true' || it.properties._free_gift === true);
          if (isGift) giftLine = it; else units += it.quantity;
        });
        if (units >= GIFT.threshold && !giftLine) addGift();
        else if (giftLine && (units < GIFT.threshold || c.item_count === 0)) removeGift(giftLine.key);
      }).catch(function () {});
  }
  function addGift() {
    GIFT.busy = true;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: GIFT.variant, quantity: 1, properties: { _free_gift: 'true' } }], sections: sectionsToRender(), sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (p) { GIFT.busy = false; renderDrawer(p); }).catch(function () { GIFT.busy = false; });
  }
  function removeGift(key) {
    GIFT.busy = true;
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ id: key, quantity: 0, sections: sectionsToRender(), sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (p) { GIFT.busy = false; renderDrawer(p); }).catch(function () { GIFT.busy = false; });
  }
  var giftTimer;
  function scheduleGiftCheck() { clearTimeout(giftTimer); giftTimer = setTimeout(checkGift, 350); }

  /* ---------- robust cart mutations (drawer only) ----------
     We own BOTH quantity changes and removal inside the drawer instead of Dawn's
     updateQuantity(), which has null-reference edge cases (it shows "There was an
     error while updating your cart" and breaks the last-item / empty-cart path).
     We call /cart/change.js ourselves, re-render the drawer + cart bubble from the
     returned sections, and never surface a scary error. Scoped to #CartDrawer so
     the main /cart page keeps using Dawn's own handlers. */
  function applyCartSections(state) {
    try {
      var cdw = document.querySelector('cart-drawer');
      if (cdw && state && typeof state.item_count !== 'undefined') cdw.classList.toggle('is-empty', state.item_count === 0);
      if (state && state.sections) {
        if (state.sections['cart-drawer']) {
          var d = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
          var ni = d.querySelector('.drawer__inner'), ci = document.querySelector('#CartDrawer .drawer__inner');
          if (ni && ci) ci.innerHTML = ni.innerHTML;
        }
        if (state.sections['cart-icon-bubble']) {
          var b = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html');
          var nb = b.querySelector('.shopify-section') || b.body, cb = document.getElementById('cart-icon-bubble');
          if (nb && cb) cb.innerHTML = nb.innerHTML;
        }
      }
      scheduleGiftCheck();
      checkFreeShip();
    } catch (e) {}
  }
  // Centered loader — attached to <cart-drawer> (NOT .drawer__inner) so it survives the re-render.
  function getLoader() {
    var dr = document.querySelector('cart-drawer');
    if (!dr) return null;
    var l = dr.querySelector('.sc-loading');
    if (!l) {
      l = document.createElement('div');
      l.className = 'sc-loading';
      l.setAttribute('aria-hidden', 'true');
      l.innerHTML = '<span class="sc-spinner" role="status" aria-label="Updating cart"></span>';
      dr.appendChild(l);
    }
    return l;
  }
  function showLoader() { var l = getLoader(); if (l) l.classList.add('show'); }
  function hideLoader() { var l = getLoader(); if (l) l.classList.remove('show'); }
  var loaderStart = 0;
  function changeLine(line, qty) {
    if (changeLine._busy || !line) return;
    changeLine._busy = true;
    showLoader();
    loaderStart = (window.performance && performance.now) ? performance.now() : 0;
    var d = document.querySelector('cart-drawer');
    var ids = (d && d.getSectionsToRender) ? d.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: ids, sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) { applyCartSections(state); })
      .catch(function () {})
      .finally(function () {
        changeLine._busy = false;
        // keep the spinner on screen at least ~300ms so it never just flashes
        var elapsed = ((window.performance && performance.now) ? performance.now() : 0) - loaderStart;
        var wait = Math.max(0, 320 - elapsed);
        setTimeout(hideLoader, wait);
      });
  }
  function removeLine(rb) {
    var line = parseInt(rb.getAttribute('data-index'), 10);
    if (line) changeLine(line, 0);
  }
  // Capture phase → run before (and suppress) Dawn's handlers.
  // Quantity: the +/- buttons (quantity-input) and typing both fire a 'change' on the input.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('#CartDrawer .quantity__input')) return;
    e.stopImmediatePropagation();
    var min = parseInt(input.getAttribute('min'), 10); if (isNaN(min)) min = 1;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < min) val = min;
    input.value = val;
    changeLine(parseInt(input.getAttribute('data-index'), 10), val);
  }, true);
  // Variant swap: the per-line variant <select>. Shopify has no "change variant"
  // endpoint, so we atomically set the old variant qty->0 and the new variant qty->same
  // via /cart/update.js (keyed by variant id), then re-render the drawer.
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('#CartDrawer .sc-variant-select')) return;
    e.stopImmediatePropagation();
    var oldId = sel.getAttribute('data-current'), newId = sel.value;
    if (!newId || newId === oldId) return;
    var qty = parseInt(sel.getAttribute('data-qty'), 10) || 1;
    swapVariant(oldId, newId, qty, sel);
  }, true);
  function swapVariant(oldId, newId, qty, sel) {
    if (changeLine._busy) { if (sel) sel.value = oldId; return; }
    changeLine._busy = true;
    showLoader();
    loaderStart = (window.performance && performance.now) ? performance.now() : 0;
    var d = document.querySelector('cart-drawer');
    var ids = (d && d.getSectionsToRender) ? d.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
    var updates = {}; updates[oldId] = 0; updates[newId] = qty;
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: ids, sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) { applyCartSections(state); })
      .catch(function () { if (sel) sel.value = oldId; })
      .finally(function () {
        changeLine._busy = false;
        var elapsed = ((window.performance && performance.now) ? performance.now() : 0) - loaderStart;
        setTimeout(hideLoader, Math.max(0, 320 - elapsed));
      });
  }
  // Removal: the trash button.
  document.addEventListener('click', function (e) {
    var rb = e.target.closest && e.target.closest('cart-remove-button');
    if (!rb || !rb.closest('#CartDrawer')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    removeLine(rb);
  }, true);

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    // coupons
    if (e.target.closest('[data-sc-coupon-remove]')) { e.preventDefault(); removeCoupon(); return; }
    if (e.target.closest('[data-sc-coupons-open]')) { e.preventDefault(); openCoupons(); return; }
    if (e.target.closest('[data-scp-close]')) { closeCoupons(); return; }
    var card = e.target.closest('[data-scp-apply]');
    if (card && !card.disabled) { applyCode(card.getAttribute('data-scp-apply')); return; }
    if (e.target.closest('[data-scp-apply-typed]')) { applyCode(q('#scp-input') && q('#scp-input').value); return; }
    if (OVERLAY && e.target === OVERLAY) { closeCoupons(); return; }
    // order note
    var noteOpen = e.target.closest('[data-sc-note-open]');
    if (noteOpen) { e.preventDefault(); openNote(noteOpen); return; }
    if (e.target.closest('[data-sc-note-close]')) { closeNote(); return; }
    if (e.target.closest('[data-sc-note-save]')) { saveNote(); return; }
    if (NOTE_OVERLAY && e.target === NOTE_OVERLAY) { closeNote(); }
  });
  document.addEventListener('input', function (e) { if (e.target && e.target.id === 'siora-note-input') noteCount(); });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-sc-coupon-form]');
    if (f) { e.preventDefault(); var i = f.querySelector('input'); applyCode(i && i.value); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.id === 'scp-input') { e.preventDefault(); applyCode(e.target.value); }
    if (e.key === 'Escape' && PANEL && PANEL.classList.contains('open')) closeCoupons();
    if (e.key === 'Escape' && NOTE && NOTE.classList.contains('open')) closeNote();
  });

  /* ---------- fix: keep <cart-drawer>.is-empty in sync after Dawn re-renders ----------
     Dawn's renderContents() (used by every add path — product forms, the upsell
     "+Add", and the SkinInsights tool) only strips `is-empty` from `.drawer__inner`,
     never from the outer <cart-drawer>. Our own remove handler sets `is-empty` on the
     outer element when the cart empties, so after "remove all → re-add" the stale class
     stays and `cart-drawer.is-empty .drawer__inner{display:grid;align-items:center}`
     collapses the item rows (blank cart). We patch renderContents to re-sync the class
     from the freshly rendered content (presence of a real line item). */
  function patchDrawerEmptyState() {
    try {
      var CD = window.customElements && customElements.get('cart-drawer');
      if (!CD || !CD.prototype.renderContents || CD.prototype._siEmptyPatched) return;
      var orig = CD.prototype.renderContents;
      CD.prototype.renderContents = function (state) {
        orig.call(this, state);
        this.classList.toggle('is-empty', !this.querySelector('.sc-item'));
        checkFreeShip();
      };
      CD.prototype._siEmptyPatched = true;
    } catch (e) {}
  }

  /* ---------- init ---------- */
  function init() {
    patchDrawerEmptyState();
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer').then(patchDrawerEmptyState).catch(function () {});
    }
    PANEL = document.querySelector('.siora-coupons');
    OVERLAY = document.querySelector('.siora-coupons-overlay');
    if (PANEL && !OVERLAY) { OVERLAY = document.createElement('div'); OVERLAY.className = 'siora-coupons-overlay'; document.body.appendChild(OVERLAY); }
    noteEls();
    initFreeShip();
    readGiftCfg();

    // reopen the cart drawer after a /discount/ redirect
    try { if (sessionStorage.getItem('siora_open_cart')) { sessionStorage.removeItem('siora_open_cart'); setTimeout(openCartDrawer, 400); } } catch (e) {}

    // free-gift triggers: page load, cart-count mutations, Dawn cartUpdate
    scheduleGiftCheck();
    var bubble = document.querySelector('#cart-icon-bubble');
    if (bubble) new MutationObserver(scheduleGiftCheck).observe(bubble, { childList: true, subtree: true, characterData: true });
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, scheduleGiftCheck); } catch (e) {}
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* ------------------------------------------------------------------
   Cart drawer stacking guard
   While the cart drawer is open nothing may paint over it — not the
   floating product video, not the WhatsApp button, not an app popup.
   Those widgets are injected by third parties at arbitrary z-indexes
   (the WhatsApp button and EcomSend both mount late and one uses the
   max 32-bit z-index), so chasing selectors would break the next time
   an app updates. Instead: hide anything stacked at or above the
   drawer while it is open, and restore each element exactly on close.
------------------------------------------------------------------ */
(function () {
  if (!window.MutationObserver) return;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else { start(); }

  function start() {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  // Part of the drawer experience — these live outside <cart-drawer> but must stay visible.
  var KEEP = '.siora-coupons,.siora-note-sheet,.cart-drawer__overlay,#CartDrawer-Overlay';
  var hidden = [];

  function drawerZ() {
    var z = parseInt(getComputedStyle(drawer).zIndex, 10);
    return isNaN(z) ? 1000 : z;
  }

  function shouldHide(el, z) {
    if (el === drawer || drawer.contains(el)) return false;
    if (el.closest && (el.closest('cart-drawer') || el.closest(KEEP))) return false;
    if (el.dataset && el.dataset.cdHidden) return false;
    var cs = getComputedStyle(el);
    if (cs.position !== 'fixed' && cs.position !== 'sticky') return false;
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    var ez = parseInt(cs.zIndex, 10);
    if (isNaN(ez) || ez < z) return false;          // auto/lower z can never cover the drawer
    var r = el.getBoundingClientRect();
    return r.width > 4 && r.height > 4;             // skip zero-size probes/trackers
  }

  function hide(el) {
    el.dataset.cdHidden = '1';
    el.dataset.cdVis = el.style.visibility || '';
    el.dataset.cdPe = el.style.pointerEvents || '';
    el.style.visibility = 'hidden';                  // also makes the subtree non-interactive
    el.style.pointerEvents = 'none';
    hidden.push(el);
  }

  function sweep(root) {
    var z = drawerZ();
    var scope = root && root.nodeType === 1 ? root : document.body;
    if (scope !== document.body && shouldHide(scope, z)) hide(scope);
    var all = scope.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) if (shouldHide(all[i], z)) hide(all[i]);
  }

  function restore() {
    hidden.forEach(function (el) {
      el.style.visibility = el.dataset.cdVis || '';
      el.style.pointerEvents = el.dataset.cdPe || '';
      delete el.dataset.cdHidden; delete el.dataset.cdVis; delete el.dataset.cdPe;
    });
    hidden = [];
  }

  // Widgets that mount while the drawer is already open still get caught.
  var late = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1) sweep(n);
      }
    }
  });

  function sync() {
    var open = drawer.classList.contains('active');
    document.documentElement.classList.toggle('cd-open', open);
    if (open) { sweep(document.body); late.observe(document.body, { childList: true, subtree: true }); }
    else { late.disconnect(); restore(); }
  }

  new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  sync();
  }
})();
